import { saveAs } from "file-saver"
import { formatFileInfo } from "./formatFileInfo"

const downloadFile = (file) => {
    const filename = formatFileInfo(file.key, 'name')
    saveAs(file.link, filename)
}

export { downloadFile }